module.exports = __webpack_public_path__ + "img/icone-soy.28685d71.svg";